export default "__VITE_PUBLIC_ASSET__c7620711__"